
const initialState = {
    unlimitedPackage: {
        name: "Unlimited SMS",
        amount: "Unlimited",
        price: "4.99",
    },
    bulkPackages: [
        {
            id: "S",
            name: "Small",
            amount: "2,500",
            price: "15",
        },
        {
            id: "M",
            name: "Medium",
            amount: "10,000",
            price: "55",
        },
        {
            id: "L",
            name: "Large",
            amount: "100,000",
            price: "470",
        },
        {
            id: "XL",
            name: "Call Center",
            amount: "1,000,000",
            price: "4,000",
        },
    ]
}

const Plans = (state = initialState, action) => {
    switch(action.type) {
        default:
            return state;
    }
}

export default Plans;